import styled from '@emotion/styled';

export const TagsContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
  padding: 25px 0;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  margin: 0 auto;
`;

export const TagCount = styled.span`
  font-weight: bold;
  margin-left: 5px;
`;
